import { useEffect, useRef } from 'react';

/**
 * Effect that will run at most once, and only the first time the passed `condition` is true
 */
export default function useEffectOnceWhen(condition: boolean, effect: () => void) {
  const hasRun = useRef(false);
  useEffect(() => {
    if (condition && !hasRun.current) {
      hasRun.current = true;
      effect();
    }
  }, [condition, effect]);
}
